export function fetchSendNpwp(formData) {
  let file = new FormData();
  file.append("file", formData, formData.name);
  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/npwp`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: file,
    }
  ).then((response) => response.json());
}

export function fetchSendPph(formData) {
  let file = new FormData();
  file.append("file", formData, formData.name);
  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/document-pph`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: file,
    }
  ).then((response) => response.json());
}

export function fetchSendSuratSubdomain(formData) {
  let file = new FormData();
  file.append("file", formData, formData.name);
  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/surat-subdomain`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: file,
    }
  ).then((response) => response.json());
}

export function fetchSendDomainTerm(files) {
  const formData = new FormData();

  files.forEach((file, index) => {
    formData.append(`domain_upload[${index}]`, file.domain_upload);
    formData.append(`domain_value[${index}]`, file.domain_value);
    formData.append(`domain_name[${index}]`, file.domain_name);
  });

  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/domain-terms`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    }
  ).then((response) => response.json());
}

export default function postKTP(fileData) {
  let file = new FormData();
  file.append(typeof fileData === "string" ? "file_base64" : "file", fileData);

  return fetch(
    `${process.env.REACT_APP_BASE_API}order-api/api/v1/file/upload/idcard`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: file,
    }
  );
}

export function fetchMyVoucher() {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/getMyVoucher.php`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "include", // Untuk mengirim session cookies
    }
  ).then((response) => response.json());
}

export function fetchCheckOnlineId(claim) {
  return fetch(`https://online.id/api/check-claim/${claim}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((response) => response.json());
}

export function fetchCheckOnlineIdExist(email) {
  return fetch(`https://online.id/api/exist/${email}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }).then((response) => response.json());
}

export function fetchCheckOmgId(username) {
  // Use WHMCS proxy endpoint to avoid CORS issues
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/checkOmgIdUsername.php?username=${encodeURIComponent(username)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "include", // Untuk mengirim session cookies
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      console.error("Error checking omg.id username:", error);
      return {
        code: 500,
        result: "error",
        message: error.message || "Failed to fetch",
        data: null,
      };
    });
}

export function fetchCheckOmgIdExist(email) {
  // Use WHMCS proxy endpoint to avoid CORS issues
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/checkOmgIdEmail.php?email=${encodeURIComponent(email)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "include", // Untuk mengirim session cookies
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      // Return error format yang konsisten untuk handling di cartSlice
      // Jangan throw error, return object dengan format yang sama
      console.error("Error checking omg.id email:", error);
      return { 
        code: 500,
        result: 'error', 
        message: error.message || 'Failed to fetch',
        data: { exist: false } 
      };
    });
}

export function fetchBundleRegisterOmgId(data) {
  return fetch(
    `${process.env.REACT_APP_BASE_API}order/apis/bundleRegisterOmgId.php`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      credentials: "include",
      body: JSON.stringify(data),
    }
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      console.error("Error registering omg.id:", error);
      return {
        code: 500,
        result: "error",
        message: error.message || "Failed to register omg.id",
        data: null,
      };
    });
}